import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { updateDidFailure, updateDidSuccess } from "../slices/features/did";
import { RequestTypes } from "../types";

const didsService = new AppService();

function* UpdateDid(action: any) {
  const { payload } = action;
  const { id, data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      didsService.updateDid,
      baseUrl,
      id,
      data
    );

    payload?.cbSuccess && payload?.cbSuccess();

    toast.success("Did updated");

    yield put(updateDidSuccess({ ...response }));
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(updateDidFailure({ statusCode, statusText }));
  }
}

export function* watchUpdateDid() {
  yield takeLatest(RequestTypes.UPDATE_DID_REQUEST, UpdateDid);
}
